module.exports = __webpack_public_path__ + "img/4.07616660.png";